export class Marker {
	public url: string;

	constructor(url) {

		this.url = url;
	}
}
